export default __webpack_public_path__ + "static/media/car-disabled.652946a4.webp";